<template>
    <VeeForm :validation-schema="regValidationSchema" v-slot="{ handleSubmit, errors }" @invalid-submit="onInvalidSubmit" as="div">
        <form class="reg-form d-flex align-items-center d-md-flex gap-2" @submit="handleSubmit($event, onRegSubmit)" method="post" :action="this.baseUrl + '/enter-reg-submit'" ref="regForm">
            <div class="d-flex flex-column">
                <Popper :content="errors.reg_plate" arrow placement="top" class="d-inline-block m-0 border-0" :show="errors.reg_plate ? true : false">
                    <Field id="reg_plate" name="reg_plate" type="text" class="reg-input fw-bold my-md-2 my-lg-0" :value="reg" placeholder="Enter Reg" autocomplete="off"/>
                </Popper>
            </div>
            <button type="submit" class="btn btn-custom-white">
                Search again
            </button>
        </form>
    </VeeForm>
</template>

<script>
    import { Form as VeeForm, Field } from 'vee-validate';
    import * as yup from 'yup';

    export default {
        props: ['postcode', 'imageBasePath', 'reg'],
        components: {
            VeeForm,
            Field
        },
        data() {
            const regValidationSchema = yup.object({
                'reg_plate': yup.string().required('Registration is required')
            });

            return {
                regValidationSchema,
                baModalOpen: false,
                foundOrder: []
            }
        },
        mounted() {

        },
        methods: {
            async onRegSubmit(values, actions) {
                this.emitter.emit('isLoading', true);
                let vm = this;
                var registration = values.reg_plate;
                var postcode = this.postcode;

                const response = await axios.post('/ajax/validate_reg/' + registration);

                if(response.data.car_exists == true)
                {
                    //If registration has at least 1 size option, check it has at least 1 option that is same front/rear
                    if(typeof response.data.car.options !== 'undefined' && response.data.car.options.length > 0)
                    {
                        var sizes = vm.sortSameSizeFrontAndRear(response.data.car.options);

                        //Find matching order from reg/sizes
                        var order = await vm.findOrderMatchingRegAndSize(registration, sizes, postcode);

                        //If a matching order has been found, launch buy again modal
                        if(order.data) {
                            this.emitter.emit('isLoading', false);
                            vm.baModalOpen = true;
                            vm.foundOrder = order.data;

                            //Track Buy Again Modal opening
                            if(typeof(this.$gtag) !== 'undefined') {
                                this.$gtag.event('buy_again_modal', {
                                    'event_category' : 'BuyAgainModal',
                                    'event_label': '/seen-reg-' + registration
                                });
                            }
                            else {
                                console.log('gtag not loaded');
                            }
                        }
                        else {
                            vm.$refs.regForm.submit();
                        }
                    }
                    else {
                        this.emitter.emit('isLoading', false);
                        actions.setFieldError('reg_plate', 'No size options found for this registration');
                    }
                }
                else {
                    this.emitter.emit('isLoading', false);

                    //Custom validation, registration not found
                    actions.setFieldError('reg_plate', 'Registration not found.');
                }
            },
            // Following functions are for use with the Buy Again Modal
            sortSameSizeFrontAndRear: function(options) {
                var front_and_rear_same_sizes = [];

                //Loop through and check if any size options have the same front/rear sizes.
                _.forEach(options, function(value, index) {
                    if(value.back === '(Same as front tyre)') {
                        var size = value.front.split('/');
                        var formatted_size = size[0] + '/' + size[1] + 'R' + size[2].substr(0, 2);

                        front_and_rear_same_sizes.push(formatted_size);
                    }
                });

                return _uniq(front_and_rear_same_sizes);
            },
            async findOrderMatchingRegAndSize(registration, sizes, postcode) {
                var formData = new FormData();

                formData.append('registration', registration);
                _.forEach(sizes, function(value, index) {
                    formData.append('sizes[]', value);
                });
                formData.append('postcode', postcode);

                var response = await axios.post('/ajax/buy_again_modal', formData);

                return response;
            },
            onInvalidSubmit({ values, errors, results }) {
                //Focus first invalid field
                var firstInvalidField = document.getElementsByName(Object.keys(errors)[0]);
                firstInvalidField[0].focus();
            },
        },
        computed: {

        }
    }
</script>
<style lang="scss" scoped>
    .error {
        color: #F73C44;
    }
    .reg-input {
        border: 0;
        width: 130px;
        padding: 8px 5px;
        border-radius: 32px;
        background: #FDD52E !important;
        background-color: #FDD52E !important;
        border: 1px solid #CAAB25;
        text-align: center;
        color: #171717;
        text-transform: uppercase;
        &::placeholder {
            color: #171717;
            opacity: 1;
        }
    }
    .reg-postcode {
        height: 35px;
        font-size: 1rem;
    }
</style>
